import React from 'react'
import { WemoloTypography } from '../Wemolo'
import styles from './Empty.module.css'

export const Empty = ({
    title,
    subtitle,
    action
}: {
    title?: string
    subtitle?: string
    /** Optional call-to-action (e.g. a retry button) rendered below the subtitle. */
    action?: React.ReactNode
}) => {
    return (
        <div className={styles.root}>
            <div className={styles.iconCircle}>
                <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                    <line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
            </div>
            <WemoloTypography variant="title-large" tag="div" className={styles.title}>
                {title || 'No data available'}
            </WemoloTypography>
            <WemoloTypography variant="body-small" tag="div" className={styles.subtitle}>
                {subtitle || 'There are no items to display at the moment.'}
            </WemoloTypography>
            {action && <div className={styles.action}>{action}</div>}
        </div>
    )
}
